import React from "react";
import { connect } from "react-redux";
import BarChart from "../graph-plots/bar";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import StatsCard from "../../../../Components/StatsCard";
import { transformFilterMetaData } from "../../../../utils";
import { getDistricts } from "../../../../actionCreators/DropDown";
import { getFilterMetaData } from "../../../../actionCreators/Property";
import { Typography, Row, Col, Button, Card, Modal, Select, Spin } from "antd";
import { UploadOutlined, PlusOutlined, HomeOutlined } from "@ant-design/icons";

import {
  formatLabelFunction,
  customColorFunction,
  formatYearlyTotalAndPaidTax,
} from "../../../../utils/reportsUtils";
import TableSearch from "../../../../Components/TableSearch";
import {
  getTotalETI,
  getTotalETO,
  getTotalPaidUnpaidPendingTax,
  getAdminUsersList,
  getTotalRegisteredPropertiesFiscalYear,
} from "../../../../actionCreators/HomePage";

const HomePage = ({
  user,
  totalETI,
  totalETO,
  districts,
  getTotalETI,
  getTotalETO,
  getDistricts,
  filterMetaData,
  adminUsersList,
  getAdminUsersList,
  getFilterMetaData,
  totalPaidUnpaidPendingTax,
  getTotalPaidUnpaidPendingTax,
  totalRegisterPropertiesFiscalYear,
  getTotalRegisteredPropertiesFiscalYear,
}) => {
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
  };

  const history = useHistory();
  const [
    yearlyPaidAndPendingTaxExpendedData,
    setYearlyPaidAndPendingTaxExpendedData,
  ] = React.useState([]);
  const [showTaxCollectedModel, setShowTaxCollectedModel] =
    React.useState(false);
  const [taxBarData, setTaxBarData] = React.useState([]);
  const [numberOfYearsSelected, setNumberOfYearsSelected] = React.useState(10);

  const onUnitsExpandButtonClick = (event) => {
    event.preventDefault();
    setShowTaxCollectedModel(true);
  };
  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
  0 ? true : false);
  const [adminDistrictId] = React.useState(user?.currentUser?.data?.district?.id);


  React.useEffect(() => {
    if (totalPaidUnpaidPendingTax?.data?.data && numberOfYearsSelected > 9) {
      const [newTaxDetails, initialData] = formatYearlyTotalAndPaidTax(
        totalPaidUnpaidPendingTax?.data?.data,
        numberOfYearsSelected
      );
      setYearlyPaidAndPendingTaxExpendedData(newTaxDetails);
      setTaxBarData(initialData);
    }
  }, [totalPaidUnpaidPendingTax, numberOfYearsSelected]);

  React.useEffect(() => {
    getTotalETI(adminDistrictId);
    getTotalETO(adminDistrictId);
    getDistricts();
    getTotalPaidUnpaidPendingTax(adminDistrictId);
    let filterBody = ''
    if(isDistrictAdmin && adminDistrictId) {
      filterBody = JSON.stringify({
        position: null,
        district: [adminDistrictId],
        status: null,
      })
    } else {
      filterBody = JSON.stringify({
        position: null,
        district: [],
        status: null,
      })
    }
    getAdminUsersList({
      page: 1,
      pageSize: 10,
      searchString: "",
      filterBody
    });
    getFilterMetaData();
    getTotalRegisteredPropertiesFiscalYear();
  }, []);

  const filterTableData = (x) => {
    const filterBody = x.filterBody;
    if(isDistrictAdmin && adminDistrictId) {
      filterBody.district = [adminDistrictId]
    }
    getAdminUsersList({
      page: x?.page,
      pageSize: x?.size,
      searchString: x?.searchText,
      filterBody: JSON.stringify(filterBody),
    })
  }
  
  return (
    <React.Fragment>
      <div style={styles.titleButtonParent}>
        <div>
          <Typography className="heading">
            Homepage
            <span style={{ color: "grey"}}>
              {!adminDistrictId && !isDistrictAdmin ? <> ({
                districts?.data&&
                districts?.data.map((data,index)=>(
                  <span key={index}>
                    {
                     index===0?data.name:" & "+data?.name
                    }
                  </span>
                ))
              })</> : <> ({
                districts?.data&&
                districts?.data?.filter(district => district?.id === adminDistrictId).map((data,index)=>(
                  <span key={index}>
                    {
                     index===0?data.name:" & "+data?.name
                    }
                  </span>
                ))
              })</>}
            </span>
          </Typography>
        </div>
        <Button
          style={styles.uploadButton}
          type="primary"
          icon={<UploadOutlined />}
          size={"large"}
          onClick={(e) => {
            history.push("/admin/upload-lookup-data");
          }}
        >
          UPLOAD DATA
        </Button>
      </div>
      <div style={styles.contentWrapper}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <StatsCard
              title={"Total ETI"}
              value={totalETI?.data?.data}
              actionIcon={<PlusOutlined />}
              actionCaption={"add ETI"}
              actionHandler={() => history.push("/admin/add-tax-inspector")}
            />
          </Col>
          <Col span={8}>
            <StatsCard
              title={"Total ETO"}
              value={totalETO?.data?.data}
              actionIcon={<PlusOutlined />}
              actionCaption={"add ETO"}
              actionHandler={() => history.push("/admin/add-eto")}
            />
          </Col>
          <Col span={8}>
            <StatsCard
              title={"PROPERTIES REGISTERED DURING THIS FISCAL YEAR"}
              value={
                totalRegisterPropertiesFiscalYear?.data?.TotalProperties[0]
                  ?.total
              }
              actionIcon={<HomeOutlined />}
              actionCaption={"view properties"}
              actionHandler={() => history.push("/admin/properties")}
            />
          </Col>

          {/* BarChart for Total tax collected */}
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card bordered={false}>
              <Row>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <Typography className="report-stats-header">
                    Total Tax Collected
                  </Typography>
                </Col>
                <Col xs={24} sm={24} lg={12} xl={12}>
                  <Button
                    className="overlay-btn"
                    onClick={onUnitsExpandButtonClick}
                  // disabled={!(taxBarData?.length > 3)}
                  >
                    Expand
                  </Button>
                </Col>
              </Row>
              <BarChart
                data={taxBarData}
                loading={!(taxBarData?.length > 0)}
                xField="year"
                yField="tax"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                // tooltipFormatterFunction={tooltipFormatterFunction}
                isNoData={!(taxBarData?.length > 0)}
                xLabel={"Fiscal Year"}
                yLabel={"Tax (PKR)"}
              />
            </Card>
          </Col>

          {/* Paginated list of Users data */}
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            {[undefined, null].includes(filterMetaData?.data) ? (
              <div className="spin-loader">
                <Spin size="large" />
              </div>
            ) : (
              <TableSearch
                onRowClick={(x) => history.push(`/admin/edit-${x?.position === 'ETO' ? 'eto' : 'tax-inspector'}?id=${x?.id}`)}
                tableName={"users"}
                data={adminUsersList?.data}
                sendRequestParams={(x) => filterTableData(x)}
                filterMetaData={transformFilterMetaData(filterMetaData?.data)}
                loading={adminUsersList?.loading}
                isDistrictAdmin={isDistrictAdmin}
              />
            )}
          </Col>
        </Row>
      </div>

      <Modal
        title="Total Tax Collected"
        visible={showTaxCollectedModel}
        onOk={() => {
          setShowTaxCollectedModel(false);
        }}
        onCancel={() => {
          setShowTaxCollectedModel(false);
        }}
        className="expanded-modal"
        width="60%"
      >
        <div>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <Select
                  defaultValue={numberOfYearsSelected}
                  onChange={(value) => {
                    setNumberOfYearsSelected(value);
                  }}
                >
                  <Select.Option value={10}>Last 10 years</Select.Option>
                  <Select.Option value={20}>Last 20 years</Select.Option>
                  <Select.Option value={30}>Last 30 years</Select.Option>
                </Select>
              </div>
              <BarChart
                data={yearlyPaidAndPendingTaxExpendedData} // data={yearlyPaidAndPendingUnits}
                loading={!(taxBarData?.length > 0)} // loading={props?.yearlyPaidAndPendingUnits?.loading}
                xField="year"
                yField="tax"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                isNoData={!(taxBarData?.length > 0)} // isNoData={!props?.yearlyPaidAndPendingUnits?.data?.length}
                xLabel={"Fiscal Year"}
                yLabel={"Tax (PKR)"}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </React.Fragment>
  );
};
const mapStateToProps = ({
  user: user,
  dropDown: { districts },
  property: { filterMetaData },
  homePage: {
    totalETI,
    totalETO,
    adminUsersList,
    totalPaidUnpaidPendingTax,
    totalRegisterPropertiesFiscalYear,
  },
}) => ({
  user,
  totalETI,
  totalETO,
  districts,
  adminUsersList,
  filterMetaData,
  totalPaidUnpaidPendingTax,
  totalRegisterPropertiesFiscalYear,
});

const mapDispatchToProps = (dispatch) => ({
  
  getTotalETI: bindActionCreators(getTotalETI, dispatch),
  getTotalETO: bindActionCreators(getTotalETO, dispatch),
  getDistricts: bindActionCreators(getDistricts, dispatch),
  getAdminUsersList: bindActionCreators(getAdminUsersList, dispatch),
  getFilterMetaData: bindActionCreators(getFilterMetaData, dispatch),
  getTotalRegisteredPropertiesFiscalYear: bindActionCreators(
    getTotalRegisteredPropertiesFiscalYear,
    dispatch
  ),
  getTotalPaidUnpaidPendingTax: bindActionCreators(
    getTotalPaidUnpaidPendingTax,
    dispatch
  ),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
